define('languages/sv_SE',[],function () {
  'use strict';
  return {
    //MENU
    'menu.home': 'Hem',
    'menu.overview': 'Översikt',
    'menu.weekly_offers': 'Kampanjer',
    'menu.my_media': 'Min media',
    'menu.my_ads': 'Mitt innehåll',
    'menu.settings': 'Inställningar',
    'menu.help': 'Hjälp',
    'menu.logout': 'Logga ut',

    //PAGE TITLES
    'page_titles.home': 'Hem',
    'page_titles.news': 'Nyheter',
    'page_titles.edit_news_item': 'Redigera nyhet',
    'page_titles.overview': 'Översikt',
    'page_titles.weekly_offers': 'Kampanjer',
    'page_titles.content': 'Innehåll',
    'page_titles.my_media': 'Min media',
    'page_titles.my_ads': 'Mitt innehåll',
    'page_titles.select_template': 'Välj mall',
    'page_titles.create_ad': 'Skapa innehåll',
    'page_titles.edit_ad': 'Redigera innehåll',
    'page_titles.settings': 'Inställningar',
    'page_titles.templates': 'Mallar',
    'page_titles.campaigns': 'Kampanjer',
    'page_titles.help': 'Hjälp',
    'page_titles.logout': 'Logga ut',

    //HEADER
    'header.app_name': 'ICA Butiks-TV App',
    'header.menu': 'Meny',
    'header.overview': 'Översikt',
    'header.select_store_modal.switch_store': 'Byt butik?',
    'header.select_store_modal.select_store': 'Välj butik',
    'header.select_store_modal.switch': 'Byt',

    //FOOTER
    'footer.text': 'Support teknik: <a href="mailto:itsupport.butik@ica.se">itsupport.butik@ica.se</a> eller 0771-510 100, val 2<br>Kontakt till Butiks-tv: <a href="mailto:ica.butikstv@ica.se">ica.butikstv@ica.se</a><br>Kontakt intern-tv: <a href="mailto:interntv@ica.se">interntv@ica.se</a>',

    //LOGIN
    'login.label.username': 'Användarnamn',
    'login.label.password': 'Lösenord',
    'login.label.email': 'E-postadress',
    'login.placeholder.username': 'fornamn.efternamn@ica.se',
    'login.placeholder.password': '●●●●●',
    'login.placeholder.email': 'fornamn.efternamn@ica.se',
    'login.button.login': 'Logga in',
    'login.button.reset': 'Återställ',
    'login.link.login': 'Logga in',
    'login.link.forgot_password': 'Glömt lösenord?',
    'login.text.forgot_password': '<p>Om du har glömt ditt lösenord, skriv in din e-postadress nedan och tryck på "Återställ".</p><p>Du kommer få ett mail med en länk där du kan ange ett nytt lösenord.</p>',
    'login.text.password_reset': '<p>Ett e-postmeddelande har skickats till din adress med en länk. Följ instruktionerna i meddelandet för att återställa ditt lösenord.</p>',
    'login.text.login_error': 'Något gick fel, kontrollera ditt namn och lösenord och försök igen.',

    //CHANGE PASSWORD
    'change_password.header.change_password': 'Byt lösenord',
    'change_password.label.old_password': 'Gammalt lösenord',
    'change_password.label.new_password': 'Nytt lösenord',
    'change_password.button.send': 'Skicka',
    'change_password.error': 'Du måste ange ditt gamla och nya lösenord',
    'change_password.success': 'Ditt lösenord är ändrat!',

    //HOME
    'home.link.edit_news': 'Redigera nyheter',

    //NEWS
    'news.header.title': 'Rubrik',
    'news.header.start_date': 'Publiceringsdatum',
    'news.header.end_date': 'Slutdatum',
    'news.header.pinned': 'Visas överst',
    'news.header.profiles': 'Profil',
    'news.header.edit': 'Redigera',
    'news.header.delete': 'Ta bort',
    'news.label.header': 'Rubrik',
    'news.label.date': 'Datum (om du anger ett framtida datum publiceras nyheten då).',
    'news.label.end_date': 'Slutdatum (om du anger ett datum här slutar nyheten visas då)',
    'news.label.text': 'Text',
    'news.button.add_news_item': 'Lägg till nyhet',
    'news.button.save': 'Spara',
    'news.button.edit': 'Redigera',
    'news.button.remove': 'Ta bort',
    'news.button.remove.confirm': 'OK?',

    //NEWSFORM
    'newsform.button.save': 'Spara nyhet',
    'newsform.feedback.news_item_saved': 'Din nyhet är sparad!',


    //OVERVIEW
    'overview.intro.heading': 'Nedan visas dina skärmar på kartan för respektive zon. Klicka på önskad skärm för att skapa eget innehåll i mallar, ladda upp lokal film eller bild.',
    'overview.intro.text': 'Saknas butikskarta? Kontakta support@visualart.com för vidare instruktioner.',
    'screens.header.image': 'Bild',
    'screens.header.title': 'Namn',
    'screens.header.zone': 'Zon',
    'screens.header.tags': 'Taggar',
    'screens.header.preview_loop': 'Granska loop',
    'screens.button.map_view': 'Karta',
    'screens.button.list_view': 'Lista',

    //SCREEN
    'screen.button.central_content': 'Centralt',
    'screen.button.local_content': 'Lokalt',
    'screen.header.media': 'Media',
    'screen.header.name': 'Namn',
    'screen.header.start_date': 'Start',
    'screen.header.end_date': 'Slut',
    'screen.header.edit': 'Redigera',
    'screen.header.like': 'Gilla',
    'screen.header.delete': 'Ta bort',
    'screen.header.disconnect': 'Ta bort',
    'screen.header.booking': 'Bokning',
    'screen.button.add_existing_ad': 'Lägg till befintligt innehåll',
    'screen.button.create_new_ad': 'Skapa nytt innehåll',
    'screen.button.edit': 'Redigera',
    'screen.button.remove': 'Ta bort',
    'screen.button.remove.confirm': 'OK?',
    'screen.link.download_media': 'Högerklicka och välj "Spara som" för att ladda ner innehållet.',

    //MY MEDIA
    'file.button.add_media': 'Ladda upp nya filer',
    'file.header.media': 'Media',
    'file.header.name': 'Namn',
    'file.header.format': 'Format',
    'file.header.length': 'Längd',
    'file.header.date_added': 'Tillagd',
    'file.header.delete': 'Ta bort',
    'file.button.remove': 'Ta bort',
    'file.button.remove.confirm': 'OK?',
    'file.upload.message': 'Ladda upp filer genom att släppa dem här eller klicka för att välja.',

    //TEMPLATES
    'htmlad_template.header.thumbnail': 'Media',
    'htmlad_template.header.title': 'Namn',
    'htmlad_template.header.profile': 'Profil',
    'htmlad_template.header.category': 'Kategori',
    'htmlad_template.header.format': 'Format',
    'htmlad_template.header.date_added': 'Tillagd',
    'htmlad_template.header.action': 'Åtgärd',
    'htmlad_template.header.current': 'Aktuella',
    'htmlad_template.header.popular': 'Populära',
    'htmlad_template.header.favorite': 'Mina favoriter',
    'htmlad_template.button.choose': 'Välj',
    'htmlad_template.infotext1': 'På den här sidan väljer du en passande mall för att skapa innehåll att visa på skärmar i din butik. Du kan filtrera mallar efter format, vilka zoner de får spelas i och använda sökfältet för att hitta en mall.',
    'htmlad_template.infotext2_1': 'Du kan sortera mallar efter olika val:',
    'htmlad_template.infotext2_2': 'Sortering av <b>Aktuella</b> mallar är vald som standard och visar mallar som är säsongsbetonade och kampanjaktuella.',
    'htmlad_template.infotext2_3': 'Sortering av <b>Populära</b> mallar visar de mallar som är mest använda av alla ICA-handlare.',
    'htmlad_template.infotext3': '<b>Mina favoriter</b> - Du kan även välja dina egna favoritmallar genom att hjärtmarkera en eller flera mallar. Dina favoritmallar kan du enkelt sortera genom att välja Mina favoriter. ',
    'htmlad_template.tooltip.favorite': 'Favorit',
    'htmlad_template.tooltip.save_as_favorite': 'Spara som favorit',

    'ad_form_template.infotext': 'If you use this template with product barcodes (EAN) it will populate the template from a Kesko source with available product information. Some information will be locked from editing, others can be edited. All product information will be connected to the Kesko source for updates so if you edit connected information it will be disconnected from updates.',
    'ad_form_template.connected_infotext': 'Connected to source',
    'ad_form_template.will_disconnect_infotext': 'Will disconnect from source',
    'ad_form_template.disconnected_infotext': 'Disconnected from source',
    'ad_form_template.connected_box_text': 'Connected',
    'ad_form_template.will_disconnect_box_text': 'Connected',
    'ad_form_template.disconnected_box_text': 'Disconnected',

    //MY ADS
    'my_ads.button.create_new': 'Skapa nytt innehåll',
    'my_ads.button.back': 'Tillbaka',
    'my_ads.header.image': 'Bild',
    'my_ads.header.name': 'Namn',
    'my_ads.header.start_date': 'Startdatum',
    'my_ads.header.end_date': 'Slutdatum',
    'my_ads.header.edit': 'Redigera',
    'my_ads.header.delete': 'Ta bort',
    'my_ads.header.add': 'Lägg till',
    'my_ads.header.zones': 'Zoner',
    'my_ads.button.edit': 'Redigera',
    'my_ads.button.remove': 'Ta bort',
    'my_ads.button.remove.confirm': 'OK?',
    'my_ads.button.add': 'Lägg till',

    // FORM FIELDS
    'formfield.media.upload_text': 'Släpp din mediafil här',
    'formfield.media.browse': 'Ladda upp',
    'formfield.media.browse_library': 'Mediabanken',
    'formfield.image.upload_text': 'Släpp din bild här',
    'formfield.image.browse': 'Ladda upp',
    'formfield.image.browse_library': 'Bildbanken',
    'image.button.pick': 'Välj',
    'formfield.video.upload_text': 'Släpp din video här (mp4, mov)',
    'formfield.video.browse': 'Välj',

    //VIEW OPTIONS
    'view_options.label.select_week': 'Välj vecka',

    //SEARCH
    'search_field.placeholder': 'Sök',
    'search_field.button.search': 'Sök',


    //EDIT
    'htmladform.feedback.saving_form': 'Sparar...',
    'htmladform.feedback.htmlad_saved': 'Ditt innehåll är sparat!',
    'edit.header.ad_name': 'Filmnamn',
    'edit.label.ad_name': 'Filmnamn',
    'edit.placeholder.ad_name': 'Filmnamn',
    'edit.button.edit': 'Redigera',
    'edit.button.play': 'Spela upp',
    'edit.button.pause': 'Pausa',
    'edit.button.preview': 'Förhandsgranska',
    'edit.button.schedule': 'Schemalägg',
    'edit.button.save': 'Spara',
    'edit.button.copy_ad.disabled': 'Du måste spara innehållet innan du kan kopiera det',
    'edit.button.copy_ad': 'Kopiera innehåll',

    //SCHEDULE
    'schedule.header.schedule': 'Schema',
    'schedule.header.days': 'Veckodag',
    'schedule.header.daypart': 'Del av dag',
    'schedule.header.show_in_zones': 'Visa på zon/er:',
    'schedule.placeholder.start_date': 'Startdatum',
    'schedule.placeholder.end_date': 'Slutdatum',
    'schedule.placeholder.start_time': 'Starttid',
    'schedule.placeholder.end_time': 'Sluttid',

    //EAN FORM
    'htmlad_ean_code_form.button.choose': 'Använd EAN-kod',
    'htmlad_ean_code_form.button.scan': 'Scanna EAN-kod',
    'htmlad_ean_code_form.button.clear': 'Lås upp och rensa',
    'htmlad_ean_code_form.check.content': 'Hämta information för varan med EAN-kod',
    'htmlad_ean_code_form.check.price': 'Lås innehåll till lokalt pris med EAN-kod',
    'htmlad_ean_code_form.input.placeholder': 'EAN-kod',

    //PREVIEW
    'htmlad_player.tooltip.replay': 'Spela på nytt',
    'htmlad_player.tooltip.toggle_size': 'Ändra storlek',
    'htmlad_player.tooltip.close_player': 'Stäng förhandsgranskning',

    // VIDEO
    'videoplayer.tooltip.pause': 'Pausa',
    'videoplayer.tooltip.play': 'Spela',
    'videoplayer.tooltip.close_video': 'Stäng förhandsgranskning',

    //MEDIA
    'media.search_form.placeholder.search_media': 'Sök media',
    'media.search_form.button.search': 'Sök',
    'media.button.central_images': 'Bilder',
    'media.button.central_movies': 'Filmer',
    'media.button.local_media': 'Lokalt',
    'media.header.media': 'Media',
    'media.header.name': 'Namn',
    'media.link.close': 'Stäng',
    'media.link.select': 'Välj',
    'media.link.delete': 'Ta bort',

    //MEDIA PICKER
    'mediapicker.modal.header': 'Välj media',
    'mediapicker.header.name': 'Namn',
    'mediapicker.endpoint.images': 'Bildbanken',
    'mediapicker.endpoint.files': 'Video',
    'mediapicker.endpoint.local_media': 'Min media',
    'mediapicker.modal.show_format': 'Visa format',

    //SETTINGS
    'settingsform.button.save': 'Spara',
    'settingsform.feedback.settings_saved': 'Inställningarna sparade',

    // WEEKLY OFFERS
    'campaigns.central_campaign.infotext1': 'Här kan du hantera pågående och kommande annonsvaror på dina skärmar. Du kan förhandsgranska annonser, välja i vilka zoner annonserna ska visas och redigera delar av annonsen.',
    'campaigns.central_campaign.infotext2': 'Du kan visa eller dölja annonser i önskade zoner genom att markera rutorna till vänster i listan eller välja en enskild annons genom att klicka på ikonen (penna) för att välja zoner eller redigera informationstext.',
    'campaigns.central_campaign.infotext3': 'I filtret ovanför listan med annonser kan du filtrera efter start- och slutdatum, vilka zoner de spelas i eller fritt söka efter en annons.',

    'campaigns.central_campaign.playing_now': 'Spelar',
    'campaigns.central_campaign.paused_now': 'Pausat',

    'campaigns.central_campaign.play_ad_modal.titel': 'Spela kampanjer?',
    'campaigns.central_campaign.play_ad_modal.text': 'Är du säker på att du vill spela kampanjerna?',
    'campaigns.central_campaign.play_ad_modal.cancel': 'Avbryt',
    'campaigns.central_campaign.play_ad_modal.play': 'Spela',

    'campaigns.central_campaign.pause_ad_modal.titel': 'Pausa kampanjer?',
    'campaigns.central_campaign.pause_ad_modal.text1': 'Är du säker på att du vill spela kampanjerna?',
    'campaigns.central_campaign.pause_ad_modal.text2': 'Välj hur länge du vill pausa',
    'campaigns.central_campaign.pause_ad_modal.cancel': 'Avbryt',
    'campaigns.central_campaign.pause_ad_modal.pause': 'Pausa',

    'campaigns.local_campaign.infotext1': 'Nu kan du även visa lokala kampanjer skapade i butik på dina skärmar. Här på kampanjsidan ser du urvalet av pågående och kommande kampanjer som går att hantera. Du kan förhandsgranska, välja skärmar och redigera delar av kampanjen.',
    'campaigns.local_campaign.infotext2': 'Om du vill visa en kampanj på föreslagna skärmar/zoner klickar du bara i rutan till vänster, glöm inte att förhandsgranska. Önskar du redigera på vilken/vilka skärmar/zoner kampanjen skall visas eller om du vill ändra i informationstexten eller bild klickar du på ikonen (penna) till höger och gör dina ändringar.',
    'campaigns.local_campaign.infotext3': 'Observera att inte alla multierbjudanden presenteras nedan då det saknas information som skickas från StoreOffice. Utveckling pågår och vi arbetar på att hitta en lösning på detta.',
    'campaigns.local_campaign.infotext4': 'Fält som går att redigera:\n- Antal\n- Antal för\n- Du sparar\n- Enhet\n- Generell info\n- Högst antal köp\n- Rabatt\n- Handla andra varor för',
    'campaigns.local_campaign.infotext5': 'Det som vi beskriver som ”zoner” är den plats i butiken skärmarna sitter på, ex gång, mejeri. En butik kan ha en eller flera skärmar i en zon.',
    'campaigns.local_campaign.infotext6': 'I filtret ovanför listan med alla erbjudanden kan du filtrera efter start- och slutdatum, vilka skärmar som de är valda att spelas på eller söka fritt efter ett specifikt erbjudande.',
    'campaigns.central_offers': 'Centrala kampanjer',
    'campaigns.my_offers': 'Mina kampanjer',
    'campaigns.start_end_date': 'Start- och slutdatum',
    'campaigns.active_zones': 'Spelas i zon',
    'campaigns.search_campaign': 'Sök kampanj',
    'campaigns.header.title': 'Kampanj',
    'campaigns.header.zones': 'Spelas i zon',
    'campaigns.header.broadcast_status': 'Status',
    'campaigns.header.status': 'Status',
    'campaigns.header.edit': 'Redigera',
    'campaigns.header.playing_now': 'Spelas nu',
    'campaigns.header.playing_when_scheduled': 'Spelas schemalagt',
    'campaigns.header.paused_now': 'Pausad nu',
    'campaigns.header.paused_when_scheduled': 'Pausad schemalagt',
    'campaigns.header.locations_chosen': 'kampanjer valda',
    'campaigns.header.play_ads': 'Spela kampanjer',
    'campaigns.header.pause_ads': 'Pausa kampanjer',
    'campaigns.header.add_zones': 'Lägg till zoner',
    'campaigns.header.remove_zones': 'Ta bort zoner',
    'campaigns.item.paused_until': 'till ',
    'campaigns.modal.addzones.header': 'Välj zoner där du vill visa valda kampanjer',
    'campaigns.modal.addzones.body1': 'Välj de zoner där du vill visa alla dina valda kampanjer genom att markera rutan vid respektive zon eller den första rutan om du vill visa alla dina valda kampanjer i alla zoner.',
    'campaigns.modal.addzones.body2': 'Zoner där alla dina valda kampanjer redan visas är inaktiverade då de inte behöver väljas. Minst en zon måste väljas för att kunna spara.',
    'campaigns.modal.addzones.select_all_checkbox': 'Visa i alla zoner',
    'campaigns.modal.removezones.header': 'Välj zoner där du vill dölja valda kampanjer',
    'campaigns.modal.removezones.body1': 'Välj de zoner där du vill dölja alla dina valda kampanjer genom att markera rutan vid respektive zon eller den första rutan om du vill dölja all dina valda kampanjer i alla zoner.',
    'campaigns.modal.removezones.body2': 'Zoner där alla dina valda kampanjer inte visas är inaktiverade då de inte behöver väljas. Minst en zon måste väljas för att kunna spara.',
    'campaigns.modal.removezones.select_all_checkbox': 'Dölj i alla zoner',
    'campaigns.modal.playselected.header': 'Vill du att valda kampanjer ska spelas?',
    'campaigns.modal.playselected.body1': 'Klicka på knappen spela om du vill att alla de kampanjer du valt ska spelas.',
    'campaigns.modal.playselected.body2': 'Endast kampanjer med valda zoner kommer att spelas.',
    'campaigns.modal.pauseselected.header': 'Vill du att valda kampanjer ska pausas?',
    'campaigns.modal.pauseselected.body1': 'Klicka på knappen pausa om du vill att alla de kampanjer du valt ska pausas.',

    //MODALS
    'modal.button.close': 'Stäng',
    'modal.tooltip.close': 'Stäng',

    'modal.button.confirm': 'OK',
    'modal.button.cancel': 'Ångra',
    'modal.button.copy': 'Kopiera',
    'modal.button.delete': 'Ta bort',
    'modal.button.schedule': 'Schemalägg',
    'modal.button.play': 'Spela',
    'modal.button.pause': 'Pausa',

    'modal.header.delete': 'Är du säker på att du vill ta bort?',
    'modal.header.delete_media': 'Är du säker? Om du tar bort mediefiler som används i filmer kan dessa bli fel.',

    'modal.header.add_to_homescreen': 'Lägg till appen till hemskärmen',
    'modal.text.add_to_homescreen': 'Klicka på din menyikon och välj "Lägg till hemskärm" för att få enkel tillgång till appen',

    'modal.header.ad_saved': 'Innehållet är sparat',
    'modal.text.ad_saved': 'Ditt innehåll är nu sparat.',

    'modal.header.schedule_ad': 'Innehållet är sparat, men ej schemalagt.',
    'modal.text.schedule_ad': 'För att ditt innehåll ska synas måste du schemalägga det!',

    'modal.header.copy_ad': 'Kopiera innehåll',
    'modal.text.copy_ad': 'Detta skapar nytt innehåll med samma mall, schemaläggning och kanaler. Ändringar du inte sparat kommer försvinna på det nuvarande innehållet. Är du säker?',

    'modal.header.logged_out': 'Du har blivit utloggad',
    'modal.text.logged_out': 'Ditt innehåll är inte sparat. Öppna en ny flik och logga in igen och spara sedan på nytt.',

    'modal.header.missing_fields': 'Innehållet sparades ej',
    'modal.text.missing_fields': 'Kontrollera att samtliga tvingade fält är ifyllda och att du har givit innehållet ett namn.',

    'modal.header.disconnect_ad_from_last_zone': 'Ta bort bokning?',
    'modal.text.disconnect_ad_from_last_zone': 'Bokningen innehåller inga andra zoner, vill du ta bort bokningen?',
    'modal.header.disconnect_ads_from_last_zone': 'Ta bort bokningar?',
    'modal.text.disconnect_ads_from_last_zone': 'Allt innehåll i den eller de Intern TV bokningar du valt kommer att tas bort. Är du säker på att du vill ta bort valda bokningar?',

    'modal.header.file_uploads': 'Att tänka på',
    'modal.text.file_uploads_image': '<h3>Bild:</h3>' +
      'Rekommenderad bildstorlek för stående skärm är 1080 * 1920 pixlar<br>' +
      'Rekommenderad bildstorlek för liggande skärm är 1920 * 1080 pixlar<br>' +
      'Ladda inte upp bilder som är mindre än 500 * 500 pixlar<br>' +
      'Godkända bildformat: JPEG och PNG<br>' +
      'Högsta filstorlek: 100MB',
    'modal.text.file_uploads_video': '<h3>Video:</h3>' +
      'Rekommenderad videostorlek för stående skärm är 1080 * 1920 pixlar<br>' +
      'Rekommenderad videostorlek för liggande skärm är 1920 * 1080 pixlar<br>' +
      'Godkända videoformat: MP4, MOV<br>' +
      'Högsta filstorlek: 100MB<br>' +
      'Rekommenderad videolängd: <30 sek',

    'modal.header.duplicate_name': 'Namnet upptaget',
    'modal.text.duplicate_name': 'Det finns redan ett annat innehåll med samma namn, byt namn och försök igen',

    'modal.header.map_zone_picker': 'Välj zon på skärm',
    'modal.text.map_zone_picker': 'Den här skärmen är indelad i flera zoner. Välj vilken zon du vill se innehåll för.',

    //PREVIEW LOOP MODAL
    'previewmodal.header': 'View loop for screen ',
    'previewmodal.body': 'View the loop to see how central and local media play in zone ## at specific date and time based on scheduling, frequency, rules, over booking, fillers, loop length and communication mix.',
    'previewmodal.date': 'Datum:',
    'previewmodal.time': 'Tid:',
    'previewmodal.cancel': 'Avbryt',
    'previewmodal.view_loop': 'Visa loop',
    'previewloop.nomedia': 'Ingen data tillgänglig för den valda tidpunkten. Välj en annan tidpunkt.',

    //VIEW LOOP MODAL
    'viewloopmodal.titel.minutes_and_seconds': 'Loop on %{playerName} %{date} at %{time}. Total length %{minutes} minute(s) and %{seconds} second(s).',
    'viewloopmodal.titel.seconds': 'Loop on %{playerName} %{date} at %{time}. Total length %{seconds} second(s).',
    'viewloopmodal.titel': 'Loop on %{playerName} %{date} at %{time}.',
    'viewloopmodal.nomedia': 'Ingen data tillgänglig för den valda tidpunkten. Välj en annan tidpunkt.',

    // PAGINATION
    'pagination.button.view_all': 'Visa alla',
    'pagination.button.view_pagination': 'Tillbaka',

    //DAYS
    'All days': 'Alla dagar',
    'Monday': 'Måndag',
    'Tuesday': 'Tisdag',
    'Wednesday': 'Onsdag',
    'Thursday': 'Torsdag',
    'Friday': 'Fredag',
    'Saturday': 'Lördag',
    'Sunday': 'Söndag',

    //PIKADAY
    'pikaday': {
      previousMonth: 'Föregående månad',
      nextMonth: 'Nästa månad',
      months: ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december'],
      weekdays: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'],
      weekdaysShort: ['sön', 'mån', 'tis', 'ons', 'tor', 'fre', 'lör']
    },

    //MISC
    'date_format': 'YYYY-MM-DD',
    'time_format': 'HH.mm',

    //ERROR
    'error.404.header': 'Error: 404',
    'error.404.description': 'Sidan kunde inte hittas',
    'error.404.path': 'Sökväg',
    'error.file_upload_failed.header': 'Filuppladdning misslyckades',
    'error.file_upload_failed.message': 'Något gick fel vid uppladdningen, vänligen kontrollera din fil och försök igen senare.',
    'error.unsaved_changes.header': 'Det finns osparade ändringar',
    'error.unsaved_changes.message': 'Du har ändringar som du inte sparat. Tryck på Spara eller Avbryt längst ner för att komma vidare.',
    'error.general.ajax.header': 'Något gick fel',
    'error.general.header': 'Något gick fel',
    'error.general.message': 'Något gick fel, vänligen försök igen.',

    // FORM SECTION
    'form_section.buttons.add': 'Lägg till',
    'form_section.title.empty': 'Fältet är tomt'

  };
});

